const steps = [
  {
    step: "STEP 01",
    icon: "ri-phone-line",
    title: "お問い合わせ",
    text: "電話またはLINEにて、お品目・お部屋の状況・ご希望日時をお知らせください。京都府内なら即日訪問も可能です。",
  },
  {
    step: "STEP 02",
    icon: "ri-file-list-3-line",
    title: "無料お見積り",
    text: "現地訪問または写真見積りで、正確なお見積り金額をご提示。ご不明点はこの段階で全て解消いただけます。",
  },
  {
    step: "STEP 03",
    icon: "ri-calendar-check-line",
    title: "作業日のご予約",
    text: "お見積りにご納得いただけた場合のみ、作業日を確定。キャンセル料は作業前日までいただきません。",
  },
  {
    step: "STEP 04",
    icon: "ri-truck-line",
    title: "作業当日",
    text: "経験豊富なスタッフが京都府内自社車両で訪問。養生・分別・搬出まで、近隣にも配慮した丁寧な作業を行います。",
  },
  {
    step: "STEP 05",
    icon: "ri-recycle-line",
    title: "適正処分・リサイクル",
    text: "京都府の産廃基準に沿った適正処分。買取可能な品目は査定し、その場でお値引きさせていただきます。",
  },
  {
    step: "STEP 06",
    icon: "ri-wallet-3-line",
    title: "お支払い・完了報告",
    text: "現金・銀行振込・法人様は請求書払いに対応。写真付き作業報告書も無料でお渡しいたします。",
  },
];

export default function Flow() {
  return (
    <section id="flow" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            SERVICE FLOW
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            ご依頼から作業完了までの<span className="text-primary-500">流れ</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            はじめてのお客様でも安心。京都 不用品回収・京都 遺品整理・京都 ゴミ屋敷清掃、いずれの依頼も同じ流れです。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {steps.map((s, i) => (
            <div
              key={s.step}
              className="relative p-7 rounded-lg bg-background-50 border border-background-200"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 flex items-center justify-center rounded-md bg-accent-700 text-background-50">
                  <i className={`${s.icon} text-2xl`}></i>
                </div>
                <div>
                  <p className="font-mincho text-primary-600 tracking-widest text-xs">
                    {s.step}
                  </p>
                  <h3 className="text-lg md:text-xl font-bold text-foreground-950">
                    {s.title}
                  </h3>
                </div>
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed">
                {s.text}
              </p>
              {i < steps.length - 1 && (
                <div className="hidden lg:flex absolute -right-3 top-1/2 -translate-y-1/2 w-6 h-6 items-center justify-center text-primary-400">
                  <i className="ri-arrow-right-s-line text-3xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}